import { withStylePrefix } from '../common/withStylePrefix';
import { SvgComponent, svgTemplate } from './Svg';
import styles from './Svg.styles.scss';
export const svgDefinition = {
    baseName: 'svg',
    template: svgTemplate,
    styles: withStylePrefix(styles),
};
export const chameleonSvg = SvgComponent.compose(svgDefinition);
